import React from 'react';
import './SherlockHomepage.scss';

interface SherlockHomepageProps {
    onTrackerDashboardClick?: () => void;
    onBatcherDashboardClick?: () => void;
    onStuckWorkflowClick?: () => void;
}

const SherlockHomepage: React.FC<SherlockHomepageProps> = ({
    onTrackerDashboardClick,
    onBatcherDashboardClick,
    onStuckWorkflowClick,
}) => {
    const handleCardKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, callback?: () => void) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callback?.();
        }
    };

    return (
        <div className="sherlock-homepage">
            <div className="homepage-content">
                <div className="welcome-section">
                    <h1 className="welcome-title">Welcome to Sherlock</h1>
                </div>
                
                <div className="features-section">
                    <div 
                        className="feature-card clickable" 
                        onClick={onTrackerDashboardClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(event) => handleCardKeyDown(event, onTrackerDashboardClick)}
                    >
                        <div className="feature-icon">📊</div>
                        <h3>Refund Tracker Dashboard</h3>
                        <p>a UI tool that provides visibility into refund processing in payments, offering granular diagnostics to identify, investigate, and resolve stuck or failed refunds processing.</p>
                    </div>

                    <div
                        className="feature-card clickable"
                        onClick={onBatcherDashboardClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(event) => handleCardKeyDown(event, onBatcherDashboardClick)}
                    >
                        <div className="feature-icon">🧰</div>
                        <h3>Batcher</h3>
                        <p>Chain approved refund operations in bulk by selecting functions, uploading CSV input, and tracking job completion from one place.</p>
                    </div>

                    <div
                        className="feature-card clickable"
                        onClick={onStuckWorkflowClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(event) => handleCardKeyDown(event, onStuckWorkflowClick)}
                    >
                        <div className="feature-icon">🧭</div>
                        <h3>Stuck Workflows</h3>
                        <p>Inspect retry and PMR workflow backlogs with live state history, ticket links, and the facets needed to isolate stuck refund clusters quickly.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SherlockHomepage;
